"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var angular = require("angular");
var filter_logic_1 = require("../filter-logic");
require('./simple-filter-v3.component.css');
var COMPONENT_NAME = 'smartorg.r6.reportOptions.simpleFilterV3';
var SimpleFilterV3Component = /** @class */ (function () {
    function SimpleFilterV3Component() {
        // Initialize data
        this.isReportOptions = false;
        this.includedTreeData = []; // Replace with actual data
        this.availableTreeData = []; // Replace with actual data
        this.excludedTreeData = []; // Replace with actual data
        this.selectedIncludedNodes = [];
        this.selectedAvailableNodes = [];
        this.selectedExcludedNodes = [];
        this.filteredTreeData = [];
        this.searchCategories = '';
        this.collapseStateMap = new Map();
        this.checkIcon = 'fa-solid fa-square-check';
        this.crossIcon = 'fa-solid fa-square-xmark';
        this.list = [
            {
                key: 'Region-Select-one',
                label: 'Region-Select-one',
                parent: undefined,
                collapsed: false,
                children: [
                    { label: 'xUS-Country_Tets', icon: '', key: 'Region-Select-one-0' },
                    { label: 'Asia_Continent9', icon: '', key: 'Region-Select-one-1' },
                    { label: 'EU', icon: '', key: 'Region-Select-one-2' },
                ]
            },
            {
                label: 'NEW-NODE_TEST',
                key: 'NEW-NODE_TEST',
                collapsed: false,
                children: [
                    { label: 'Check_23', icon: '', key: 'NEW-NODE_TEST-4' },
                    { label: 'Check', icon: '', key: 'NEW-NODE_TEST-5' },
                ],
                parent: undefined
            },
        ];
        // onSelectChild(child, parentNode) {
        //     child.isActive = !child.isActive;
        // }
        // Method to handle selection for included tree
        this.onSelectIncludedNode = function (child, parentNode) {
            this.handleSelection(child, parentNode, this.selectedIncludedNodes);
        };
        // Method to handle selection for available tree
        this.onSelectAvailableNode = function (child, parentNode) {
            this.handleSelection(child, parentNode, this.selectedAvailableNodes);
        };
        // Method to handle selection for excluded tree
        this.onSelectExcludedNode = function (child, parentNode) {
            this.handleSelection(child, parentNode, this.selectedExcludedNodes);
        };
        // Generalized method to handle selection
        this.handleSelection = function (child, parentNode, targetArray) {
            child.isActive = !child.isActive;
            if (child.isActive) {
                child.parent = parentNode;
                targetArray.push(child);
            }
            else {
                targetArray.splice(targetArray.findIndex(function (item) { return item.child === child; }), 1);
            }
        };
        // Helper method to check if a node is selected
        this.isSelected = function (child, targetArray) {
            return targetArray.some(function (item) { return item.child === child; });
        };
        this.filterQuery = '';
        this.filterList = [];
        this.dropdownTagsMap = {};
        this.selectedTags = [];
        this.excludedTags = [];
        this.resetSearchQuery();
        // this.origInvertFilterFlag = angular.copy(this.invertFilter);
    }
    SimpleFilterV3Component.prototype.$onChanges = function (changesObj) {
        // console.log('Advanced', changesObj);
        var _this = this;
        if ((changesObj.allTags || changesObj.allDropdownTags) && (this.allTags || this.allDropdownTags)) {
            this.allValidTags = (this.allTags || []).filter(function (t) { return t.includes(':'); });
            if (!this.allDropdownTags) {
                return;
            }
            for (var _i = 0, _a = this.allDropdownTags; _i < _a.length; _i++) {
                var t = _a[_i];
                if (t.split(':').length !== 3) {
                    continue;
                }
                var _b = t.split(':'), key = _b[0], codedValue = _b[1], codedName = _b[2];
                var tagForSelect = atob(decodeURIComponent(codedName)) + ':' + atob(decodeURIComponent(codedValue));
                this.allValidTags.push(tagForSelect);
                this.dropdownTagsMap[tagForSelect] = t;
            }
        }
        // this.updateCategories();
        var filterLogic = filter_logic_1.createFilterLogic(this.initState);
        this.parseSimpleFilterFromString(filterLogic);
        this.makeSelectedTags();
        this.excludedTags = this.initExcludedFilterTags ? angular.copy(this.initExcludedFilterTags) : [];
        this.excludedTreeData = this.transformTagsToTreeData(this.excludedTags, this.crossIcon);
        this.validTagsWithoutExcluded = [];
        this.validTagsWithoutSelected = [];
        if (this.allValidTags) {
            this.allValidTags.forEach(function (tag) {
                if (_this.excludedTags.indexOf(tag) == -1) {
                    _this.validTagsWithoutExcluded.push(tag);
                }
            });
            this.allValidTags.forEach(function (tag) {
                if (_this.selectedTags.indexOf(tag) == -1) {
                    _this.validTagsWithoutSelected.push(tag);
                }
            });
        }
        // console.log("validtags", this.allValidTags);
        console.log(this.includedTreeData);
        console.log(this.availableTreeData);
        console.log(this.excludedTreeData);
        if (this.allValidTags) {
            this.availableTreeData = this.transformTagsToTreeData(this.allValidTags.filter(function (tag) { return _this.allIncludedTags.indexOf(tag) === -1 && _this.excludedTags.indexOf(tag) === -1; }), '', true);
        }
        this.resetFilterData();
        this.updateQuery();
        // 🟢 Step 2: Regenerate trees and restore states
        // this.includedTreeData = this.restoreTreeState(this.transformTagsToTreeData(this.allIncludedTags, this.checkIcon));
        // this.filteredTreeData = this.restoreTreeState(this.transformTagsToTreeData(this.filteredTags, this.checkIcon));
        // this.excludedTreeData = this.restoreTreeState(this.transformTagsToTreeData(this.excludedTags, this.checkIcon));
    };
    // 🟢 Helper Function: Restore Collapse State
    // private restoreTreeState(newTreeData: any[]) {
    //     return newTreeData.map(node => ({
    //         ...node,
    //         collapsed: this.collapseStateMap.get(node.label) ?? true // Default to collapsed
    //     }));
    // }
    SimpleFilterV3Component.prototype.updateCategories = function () {
        var _this = this;
        this.initExcludedFilterTags = this.initExcludedFilterTags.filter(function (tag) { return _this.allValidTags.includes(tag); });
    };
    SimpleFilterV3Component.prototype.transformTagsToTreeData = function (tags, icon, isCollapsed) {
        var _this = this;
        if (isCollapsed === void 0) { isCollapsed = false; }
        var treeData = {};
        var i = 0;
        tags.forEach(function (tag, index) {
            i++;
            var _a = tag.split(':'), category = _a[0], value = _a[1];
            if (!treeData[category]) {
                treeData[category] = {
                    label: category,
                    key: category,
                    collapsed: _this.collapseStateMap.has(category) ? _this.collapseStateMap.get(category) : isCollapsed,
                    children: []
                };
            }
            treeData[category].children.push({ label: value, icon: icon, key: category + '-' + index });
        });
        var sortedCategories = Object.keys(treeData).sort(function (a, b) { return a.localeCompare(b); });
        var sortedTreeData = {};
        sortedCategories.forEach(function (category) {
            sortedTreeData[category] = treeData[category];
        });
        treeData = sortedTreeData;
        // Convert the object into an array suitable for PrimeNG tree component
        return Object.values(treeData);
    };
    // nodeSelected(event: any) {
    //     if (event.node.parent == undefined) {
    //         event.node.collapsed = false;
    //     }
    // }
    // nodeUnSelected(event: any) {
    //     if (event.node.parent == undefined) {
    //         event.node.collapsed = true;
    //     }
    // }
    SimpleFilterV3Component.prototype.parseSimpleFilterFromString = function (filterLogic) {
        if (!filterLogic) {
            this.filterList = [];
            return;
        }
        this.filterList = filterLogic.children.map(function (f) {
            if (f instanceof filter_logic_1["default"]) {
                var tags = f.children;
                if (tags[0].split(':').length === 3) {
                    var _a = tags[0].split(':'), key = _a[0], v = _a[1], codedName = _a[2];
                    var entries_1 = tags.map(function (t) { return ({ name: atob(decodeURIComponent(t.split(':')[1])), selected: true }); });
                    return { key: key, name: atob(decodeURIComponent(codedName)), entries: entries_1, isDropdown: true };
                }
                var name_1 = tags[0].split(':')[0];
                var entries = tags.map(function (t) { return ({ name: t.split(':')[1], selected: true }); });
                return { name: name_1, entries: entries };
            }
            else {
                var filterStrArr = f.split(':');
                if (filterStrArr.length === 3) {
                    var key = filterStrArr[0], codedVal = filterStrArr[1], codedName = filterStrArr[2];
                    return {
                        key: key,
                        entries: [{ name: atob(decodeURIComponent(codedVal)), selected: true }],
                        name: atob(decodeURIComponent(codedName)),
                        isDropdown: true
                    };
                }
                var name_2 = filterStrArr[0], entry = filterStrArr[1];
                return { name: name_2, entries: [{ name: entry, selected: true }] };
            }
        });
        this.makeSelectedTags();
    };
    SimpleFilterV3Component.prototype.clearSearch = function () {
        this.searchCategories = ''; // Reset the search query
    };
    SimpleFilterV3Component.prototype.resetFilterData = function () {
        this.searchCategories = ''; // Reset the search query
        this.filteredTreeData = this.availableTreeData.map(function (node) { return (__assign({}, node, { filteredChildren: node.children || [] })); });
    };
    SimpleFilterV3Component.prototype.applyFilter = function (searchCategories) {
        console.log(searchCategories);
        if (!this.searchCategories) {
            this.resetFilterData();
            return;
        }
        var search = this.searchCategories.toLowerCase().trim();
        this.filteredTreeData = this.availableTreeData
            .map(function (node) {
            var isNodeMatch = node.label.toLowerCase().includes(search);
            // 🔹 Replace ?. with a traditional check
            var filteredChildren = node.children && Array.isArray(node.children) ? node.children.filter(function (child) { return child.label.toLowerCase().includes(search); }) : [];
            // If child match expand else collapse -> force
            if (filteredChildren.length > 0) {
                node.collapsed = false;
            }
            else {
                node.collapsed = true;
            }
            // If node itself matches or any of its children match, include it
            if (isNodeMatch || filteredChildren.length > 0) {
                return __assign({}, node, { filteredChildren: filteredChildren.length > 0 ? filteredChildren : node.children });
            }
            return null;
        })
            .filter(function (node) { return node !== null; }); // Remove null entries
    };
    SimpleFilterV3Component.prototype.makeSelectedTags = function () {
        var _this = this;
        var selectedTagsSet = new Set();
        this.filterList.forEach(function (category) {
            var categoryName = category['name'];
            var entries = category['entries'] || [];
            entries
                .filter(function (categoryEntry) { return categoryEntry.selected && categoryEntry.name; })
                .forEach(function (categoryEntry) {
                var tag = categoryName + ":" + categoryEntry.name;
                if (_this.allValidTags.includes(tag)) {
                    selectedTagsSet.add(tag);
                }
            });
        });
        this.allIncludedTags = Array.from(selectedTagsSet);
        // Preserve collapsed state before updating the tree
        // const prevStateMap = new Map();
        // if (this.includedTreeData) {
        //     this.includedTreeData.forEach((node) => {
        //         prevStateMap.set(node.label, node.collapsed);
        //     });
        // }
        // Transform and restore previous collapsed state
        // this.includedTreeData = this.transformTagsToTreeData(this.allIncludedTags, this.checkIcon).map((node) => {
        //     return {
        //         ...node,
        //         collapsed: prevStateMap.has(node.label) ? prevStateMap.get(node.label) : true, // default to true if new
        //     };
        // });
        this.includedTreeData = this.transformTagsToTreeData(this.allIncludedTags, this.checkIcon);
    };
    SimpleFilterV3Component.prototype.makeSelectedTagsOld = function () {
        var _this = this;
        this.selectedTags = [];
        this.filterList.forEach(function (category) {
            var categoryName = category['name'];
            if ('entries' in category) {
                category['entries'].forEach(function (categoryEntry) {
                    if ('selected' in categoryEntry && 'name' in categoryEntry && categoryEntry['selected'] == true) {
                        var tmpTag = categoryName + ':' + categoryEntry['name'];
                        if (_this.selectedTags.indexOf(tmpTag) == -1) {
                            _this.selectedTags.push(categoryName + ':' + categoryEntry['name']);
                        }
                    }
                });
            }
        });
    };
    SimpleFilterV3Component.prototype.verifyTag = function (tag) {
        if (!tag || !tag.includes(':')) {
            return false;
        }
        return this.allTags.some(function (t) { return t === tag; });
    };
    SimpleFilterV3Component.prototype.verifyDropdownTag = function (tag) {
        if (!tag || !tag.includes(':')) {
            return false;
        }
        var dropdownTag = this.dropdownTagsMap[tag];
        return this.allDropdownTags.some(function (t) { return t === dropdownTag; });
    };
    SimpleFilterV3Component.prototype.addTagToFilterList = function (tag) {
        if (!this.verifyTag(tag) && !this.verifyDropdownTag(tag)) {
            return;
        }
        if (tag in this.dropdownTagsMap) {
            // if (categoryName.includes('(') && categoryName.includes(')')) {
            //     const key = categoryName.split('(')[0];
            //     const name = categoryName.slice(key.length + 1, -1);
            var _a = this.dropdownTagsMap[tag].split(':'), key_1 = _a[0], codedVal_1 = _a[1], codedName = _a[2];
            if (!this.filterList.find(function (c) { return c.key && c.key === key_1; })) {
                this.filterList.push({ key: key_1, name: atob(decodeURIComponent(codedName)), entries: [], isDropdown: true });
            }
            var dropdown = this.filterList.find(function (c) { return c.key && c.key === key_1; });
            if (!dropdown.entries.find(function (en) { return en.name === atob(decodeURIComponent(codedVal_1)); })) {
                dropdown.entries.push({ name: atob(decodeURIComponent(codedVal_1)), selected: true });
            }
            this.applyChanges();
            return;
        }
        var _b = tag.split(':'), categoryName = _b[0], entry = _b[1];
        if (!this.filterList.find(function (c) { return c.name === categoryName; })) {
            this.filterList.push({ name: categoryName, entries: [] });
        }
        var category = this.filterList.find(function (c) { return c.name === categoryName; });
        if (!category.entries.find(function (en) { return en.name === entry; })) {
            category.entries.push({ name: entry, selected: true });
        }
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.addTagToExcludeList = function (tag) {
        if (this.excludedTags.indexOf(tag) == -1) {
            this.excludedTags.push(tag);
        }
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.removeTag = function (categoryIndex, entryIndex) {
        this.filterList[categoryIndex].entries.splice(entryIndex, 1);
        if (this.filterList[categoryIndex].entries.length === 0) {
            this.filterList.splice(categoryIndex, 1);
        }
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.removeCategory = function (categoryIndex) {
        this.filterList.splice(categoryIndex, 1);
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.emptyExcludedTags = function () {
        this.excludedTags = [];
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.unselectTagFromFilterList = function (tag) {
        var tmpFilterList = angular.copy(this.filterList);
        if (tag.indexOf(':') !== -1) {
            var split = tag.split(':');
            var categoryName = split[0];
            var entry = split[1];
            var entryRemoved = false;
            for (var i = 0; i < tmpFilterList.length; i++) {
                if (entryRemoved) {
                    break;
                }
                if (tmpFilterList[i]['name'] === categoryName) {
                    for (var j = 0; tmpFilterList[i]['entries'].length; j++) {
                        if (tmpFilterList[i]['entries'][j]['name'] == entry) {
                            tmpFilterList[i]['entries'].splice(j, 1);
                            entryRemoved = true;
                            if (tmpFilterList[i]['entries'].length == 0) {
                                tmpFilterList.splice(i, 1);
                            }
                            break;
                        }
                    }
                }
            }
        }
        this.filterList = angular.copy(tmpFilterList);
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.removeTagFromExcludeList = function (tag) {
        if (this.excludedTags.indexOf(tag) !== -1) {
            var idx = this.excludedTags.indexOf(tag);
            this.excludedTags.splice(idx, 1);
        }
        this.applyChanges();
    };
    SimpleFilterV3Component.prototype.updateQuery = function () {
        var filters = this.filterList.map(function (f) {
            var name = f.name, entries = f.entries, key = f.key, isDropdown = f.isDropdown;
            var tags = isDropdown
                ? entries.filter(function (en) { return en.selected; }).map(function (en) { return key + ":" + encodeURIComponent(btoa(en.name)) + ":" + encodeURIComponent(btoa(name)); })
                : entries.filter(function (en) { return en.selected; }).map(function (en) { return name + ":" + en.name; });
            return new filter_logic_1["default"](filter_logic_1.LOGIC.OR, tags);
        });
        this.filterQuery = new filter_logic_1["default"](filter_logic_1.LOGIC.AND, filters).toExp();
    };
    SimpleFilterV3Component.prototype.applyChanges = function () {
        this.makeSelectedTags();
        this.updateQuery();
        this.updateFilter({ filterQuery: this.filterQuery, excludedTags: this.excludedTags });
    };
    SimpleFilterV3Component.prototype.resetSearchQuery = function () {
        this.searchQuery = '';
    };
    SimpleFilterV3Component.prototype.updateSelectedTags = function (tag, event) {
        event.stopPropagation();
        var selectedObj;
        for (var i = 0; typeof this.selectedTags !== 'undefined' && i < this.selectedTags.length; i++) {
            if (this.selectedTags[i].toUpperCase() === tag.toUpperCase()) {
                selectedObj = this.selectedTags[i];
                break;
            }
        }
        if (typeof selectedObj === 'undefined') {
            this.addTagToFilterList(tag);
        }
        else {
            this.unselectTagFromFilterList(tag);
        }
    };
    SimpleFilterV3Component.prototype.isTagSelected = function (tag) {
        if (this.selectedTags) {
            for (var i = 0; i < this.selectedTags.length; i++) {
                if (this.selectedTags[i] === tag) {
                    return true;
                }
            }
        }
        return false;
    };
    SimpleFilterV3Component.prototype.isTagExcluded = function (tag) {
        if (this.excludedTags) {
            for (var i = 0; i < this.excludedTags.length; i++) {
                if (this.excludedTags[i] === tag) {
                    return true;
                }
            }
        }
        return false;
    };
    SimpleFilterV3Component.prototype.toggleNode = function (node) {
        node.collapsed = !node.collapsed;
        this.collapseStateMap.set(node.label, node.collapsed);
    };
    SimpleFilterV3Component.prototype.moveAllToIncluded = function () {
        var _this = this;
        // Loop through all the available tree data
        this.availableTreeData.forEach(function (parentNode) {
            // If the parent node has children, move them
            if (parentNode.children) {
                parentNode.children.forEach(function (childNode, index) {
                    _this.addToTree(_this.includedTreeData, __assign({}, childNode, { parent: parentNode, icon: _this.checkIcon, key: parentNode.label + '-include-' + index }));
                    var tag = parentNode.label + ':' + childNode.label;
                    _this.addTagToFilterList(tag);
                });
            }
            // Move the parent node itself if needed
            //this.addToTree(this.includedTreeData, parentNode);
        });
        // Clear availableTreeData
        this.availableTreeData = [];
        // Clear the selection
        this.selectedAvailableNodes = [];
        // this.cdr.detectChanges();
    };
    SimpleFilterV3Component.prototype.moveAllToExcluded = function () {
        var _this = this;
        // Loop through all the available tree data
        this.availableTreeData.forEach(function (parentNode) {
            // If the parent node has children, move them
            if (parentNode.children) {
                parentNode.children.forEach(function (childNode, index) {
                    _this.addToTree(_this.excludedTreeData, __assign({}, childNode, { parent: parentNode, icon: _this.crossIcon, key: parentNode.label + '-exclude-' + index }));
                    var tag = parentNode.label + ':' + childNode.label;
                    _this.updateExcludedTags(tag);
                });
            }
            // Move the parent node itself if needed
            _this.addToTree(_this.excludedTreeData, parentNode);
        });
        // Clear availableTreeData
        this.availableTreeData = [];
        // Clear the selection
        this.selectedAvailableNodes = [];
        // this.cdr.detectChanges();
    };
    SimpleFilterV3Component.prototype.moveAllToAvailable = function (fromExcluded) {
        var _this = this;
        // Loop through all the included tree data
        var sourceTreeData = fromExcluded ? this.excludedTreeData : this.includedTreeData;
        sourceTreeData.forEach(function (parentNode) {
            // If the parent node has children, move them
            if (parentNode.children) {
                parentNode.children.forEach(function (childNode, index) {
                    var obj = __assign({}, childNode, { parent: parentNode });
                    _this.addToTree(_this.availableTreeData, __assign({}, obj, { icon: '', key: parentNode.label + '-available-' + index }));
                    _this.removeTagsFromFilterList([obj]);
                    if (fromExcluded) {
                        _this.removeTagsFromExcludedList([obj]);
                    }
                });
            }
            // Move the parent node itself if needed
            _this.addToTree(_this.availableTreeData, parentNode);
        });
        this.resetFilterData();
        // Clear includedTreeData
        if (fromExcluded) {
            this.excludedTreeData = [];
            this.selectedExcludedNodes = [];
        }
        else {
            this.includedTreeData = [];
            this.selectedIncludedNodes = [];
            this.applyChanges();
        }
        // this.cdr.detectChanges();
    };
    SimpleFilterV3Component.prototype.moveToIncluded = function () {
        var _this = this;
        if (!this.selectedAvailableNodes || this.selectedAvailableNodes.length === 0) {
            return; // Nothing selected
        }
        // Filter selected child nodes (leaf nodes)
        var selectedChildNodes = this.selectedAvailableNodes.filter(function (tag) { return !tag.children; });
        // Add selected child nodes to includedTreeData, grouped under their parent nodes
        selectedChildNodes.forEach(function (node, index) {
            _this.addToTree(_this.includedTreeData, __assign({}, node, { icon: _this.checkIcon, key: node.parent.label + '-include-' + index }));
        });
        // Remove the selected nodes from availableTreeData
        this.removeFromTree(this.availableTreeData, selectedChildNodes);
        // this.removeFromTree(this.availableFilteredNodes(), selectedChildNodes);
        // Clear the selection after moving
        var tag = '';
        this.selectedAvailableNodes.forEach(function (item) {
            if (item.parent) {
                tag = item.parent.label + ':' + item.label;
                _this.addTagToFilterList(tag);
            }
        });
        this.selectedAvailableNodes = [];
        // this.cdr.detectChanges();
    };
    SimpleFilterV3Component.prototype.moveToExcluded = function () {
        var _this = this;
        if (!this.selectedAvailableNodes || this.selectedAvailableNodes.length === 0) {
            return; // Nothing selected
        }
        // Filter selected child nodes (leaf nodes)
        var selectedChildNodes = this.selectedAvailableNodes.filter(function (tag) { return !tag.children; });
        // Add selected child nodes to includedTreeData, grouped under their parent nodes
        selectedChildNodes.forEach(function (node, index) {
            _this.addToTree(_this.excludedTreeData, __assign({}, node, { icon: _this.crossIcon, key: node.parent.label + '-exclude-' + index }));
        });
        // Remove the selected nodes from availableTreeData
        this.removeFromTree(this.availableTreeData, selectedChildNodes);
        ///// TODO TODO TODO
        // this.removeFromTree(this.availableFilteredNodes(), selectedChildNodes);
        var tag = '';
        this.selectedAvailableNodes.forEach(function (item) {
            if (item.parent) {
                tag = item.parent.label + ':' + item.label;
                _this.updateExcludedTags(tag);
            }
        });
        // Clear the selection after moving
        this.selectedAvailableNodes = [];
        // this.cdr.detectChanges();
    };
    SimpleFilterV3Component.prototype.moveToAvailable = function (fromExcluded) {
        var _this = this;
        var sourceList = fromExcluded ? this.selectedExcludedNodes : this.selectedIncludedNodes;
        if (!sourceList || sourceList.length === 0) {
            return; // Nothing selected
        }
        // Filter selected child nodes (leaf nodes)
        var selectedChildNodes = sourceList.filter(function (tag) { return !tag.children; });
        // Add selected child nodes to availableTreeData, grouped under their parent nodes
        selectedChildNodes.forEach(function (node, index) {
            _this.addToTree(_this.availableTreeData, __assign({}, node, { icon: '', key: node.parent.label + '-available-' + index }));
        });
        // Remove the selected nodes from includedTreeData
        this.removeFromTree(fromExcluded ? this.excludedTreeData : this.includedTreeData, selectedChildNodes);
        this.removeTagsFromFilterList(selectedChildNodes);
        this.resetFilterData();
        if (fromExcluded) {
            this.removeTagsFromExcludedList(selectedChildNodes);
            this.selectedExcludedNodes = [];
        }
        else {
            this.selectedIncludedNodes = [];
        }
        this.applyChanges();
        // this.cdr.detectChanges();
    };
    // Helper function to add a node to a tree (if category exists, add child; else create category)
    SimpleFilterV3Component.prototype.addToTree = function (treeData, node) {
        if (node.parent) {
            var category_1 = node.parent.label;
            var newChildNode_1 = { label: node.label, icon: node.icon, key: node.key, collapsed: false };
            // Find the parent node (category)
            var parentNode = treeData.find(function (parent) { return parent.label === category_1; });
            // If parent node doesn't exist, create it
            if (!parentNode) {
                parentNode = { label: category_1, collapsed: false, children: [], key: category_1 };
                treeData.push(parentNode);
            }
            else {
                // 🟢 If the parent already existed, expand it
                parentNode.collapsed = false;
            }
            // Expand parent when node is added
            this.collapseStateMap.set(parentNode.label, false);
            // Check if the child node already exists to avoid duplicates
            if (!parentNode.children.some(function (child) { return child.label === newChildNode_1.label; })) {
                parentNode.children.push(newChildNode_1);
            }
        }
    };
    // updateExcludedTags(tag, event) {
    //     event.stopPropagation();
    //     let excludedObj;
    //     for (let i = 0; typeof this.excludedTags !== 'undefined' && i < this.excludedTags.length; i++) {
    //         if (this.excludedTags[i].toUpperCase() === tag.toUpperCase()) {
    //             excludedObj = this.excludedTags[i];
    //             break;
    //         }
    //     }
    //     if (typeof excludedObj === 'undefined') {
    //         this.addTagToExcludeList(tag);
    //     } else {
    //         this.removeTagFromExcludeList(tag);
    //     }
    // }
    SimpleFilterV3Component.prototype.updateExcludedTags = function (tag) {
        var excludedObj;
        for (var i = 0; typeof this.excludedTags !== 'undefined' && i < this.excludedTags.length; i++) {
            if (this.excludedTags[i].toUpperCase() === tag.toUpperCase()) {
                excludedObj = this.excludedTags[i];
                break;
            }
        }
        if (typeof excludedObj === 'undefined') {
            this.addTagToExcludeList(tag);
        }
        else {
            this.removeTagFromExcludeList(tag);
        }
    };
    SimpleFilterV3Component.prototype.removeFromTree = function (treeData, selectedNodes) {
        selectedNodes.forEach(function (selectedNode) {
            if (selectedNode.parent) {
                var category_2 = selectedNode.parent.label;
                var parentNode = treeData.find(function (parent) { return parent.label === category_2; });
                if (parentNode) {
                    // Remove the selected child node
                    parentNode.children = parentNode.children.filter(function (child) { return child.label !== selectedNode.label; });
                    // If no children left in the parent, remove the parent node
                    if (parentNode.children.length === 0) {
                        var index = treeData.indexOf(parentNode);
                        if (index > -1) {
                            treeData.splice(index, 1);
                        }
                    }
                }
            }
        });
        // this.cdr.detectChanges();
    };
    SimpleFilterV3Component.prototype.removeTagsFromFilterList = function (nodesToRemove) {
        this.filterList.forEach(function (filter) {
            nodesToRemove.forEach(function (node) {
                if (filter.name === node.parent.label) {
                    filter.entries.forEach(function (entry, index) {
                        if (entry.name === node.label) {
                            filter.entries.splice(index, 1);
                        }
                    });
                }
            });
        });
        //this.applyChanges();
    };
    SimpleFilterV3Component.prototype.removeTagsFromExcludedList = function (nodesList) {
        var _this = this;
        nodesList.forEach(function (node) {
            _this.removeTagFromExcludeList(node.parent.label + ':' + node.label);
        });
    };
    return SimpleFilterV3Component;
}());
angular.module(COMPONENT_NAME, []).component('simpleFilterV3', {
    template: require('./simple-filter-v3.component.html'),
    bindings: {
        allTags: '<',
        allDropdownTags: '<',
        initState: '<',
        initExcludedFilterTags: '<',
        displayColumns: '<',
        updateFilter: '&',
        showQuery: '@?',
        showAlert: '&?',
        excludeFilter: '<'
    },
    controller: SimpleFilterV3Component
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=simple-filter-v3.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/simple-filter-v3/simple-filter-v3.component.js